export const MAX_INPUT_LENGTH = 255
export const MAX_INDICATOR = 15
export const MAX_CONDITION = 5
export const MAX_INDUSTRY_LEVEL = 5
export const MAX_ADDITIONAL_INFO = 10
export const MAX_EXPORT_RESULT = 5000

export const IGNORE_CHARACTER = ['\\', '/', ':', '*', '?', '"', '<', '>', '|']

export const CRITERIA_GROUP = {
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  INDUSTRY: 'INDUSTRY',
  FINANCIALS: 'FINANCIALS',
}

export const OTHER_DATA = 'OTHER_DATA'

export const DEFAULT_CURRENCY = 'VND'

export const INDICATOR_ID = {
  BASIC_INFORMATION: 1,

  LOCATION: 9,
  HAS_PARENT_COMPANY: 12,

  VSIC: 21,
  ICB: 22,

  CORPORATE_BALANCESHEET: 25,
  BANK_BALANCESHEET: 39,
  SECURITIES_BALANCESHEET: 55,
  INSURANCE_BALANCESHEET: 216,
  CORPORATE_INCOMESTATEMENT: 67,
  BANK_INCOMESTATEMENT: 75,
  SECURTIES_INCOMESTATEMENT: 86,
  INSURANCE_INCOMESTATEMENT: 229,
  CORPORATE_CASHFLOWSTATEMENT: 101,
  BANK_CASHFLOWSTATEMENT: 105,
  SECURITIES_CASHFLOWSTATEMENT: 111,
  INSURANCE_CASHFLOWSTATEMENT: 244,
  CORPORATE_RATIOS: 118,
  BANK_RATIOS: 143,
  SECURITIES_RATIOS: 173,
  INSURANCE_RATIOS: 250,
  HAS_INDEPENDENT_COMPANY: 287,
}

export const INDICATOR_TYPE = {
  Text: 'Text',
  TextBox: 'TextBox',
  Number: 'Number',
  DateTime: 'DateTime',
  NumberRange: 'NumberRange',
  FloatRange: 'FloatRange',
  DateTimeRange: 'DateTimeRange',
  DropdownList: 'DropdownList',
  MultipleDropdownList: 'MultipleDropdownList',
  FinancialRange: 'FinancialRange',
  RatioRange: 'RatioRange',
  Tree: 'Tree',
  Radio: 'Radio',
}

export const INDICATOR_GROUP = {
  BASIC_INFORMATION: 'BasicInformation',
  INDUSTRY: 'Industry',
  FINANCIALS: 'Financials',
}

export const INDUSTRY_TYPE = {
  VSIC: 'VSIC',
  ICB: 'ICB',
}

export const FINANCIAL_TYPE = {
  BALANCE_SHEET: 'BALANCE_SHEET',
  INCOME_STATEMENT: 'INCOME_STATEMENT',
  CASHFLOW_STATEMENT: 'CASHFLOW_STATEMENT',
  RATIOS: 'RATIOS',
}

export const CORPORATE_TYPE = {
  CORPORATE: 'CORPORATE',
  BANK: 'BANK',
  SECURITIES: 'SECURITIES',
  INSURANCE: 'INSURANCE',
}

export const HAS_PARENT_COMPANY = {
  HAS_PARENT: 'HAS_PARENT',
  HAS_NO_PARENT: 'HAS_NO_PARENT',
}

export const HAS_PARENT_COMPANY_OPTIONS = [
  { id: HAS_PARENT_COMPANY.HAS_PARENT, name: 'screening.HAS_PARENT_COMPANY' },
  {
    id: HAS_PARENT_COMPANY.HAS_NO_PARENT,
    name: 'screening.HAS_NO_PARENT_COMPANY',
  },
]

export const LOCATION_TYPE = {
  PROVINCE: 'PROVINCE',
  DISTRICT: 'DISTRICT',
}

export const ERROR_TYPE = {
  REQUIRED: 'REQUIRED',
}

export const SAVED_CRITERIA_COLUMN_ID = {
  CRITERIA_NAME: 'screeningSavedCriteriaName',
  CREATE_AT: 'createDate',
  UPDATE_AT: 'updateDate',
}

export const PAGE_SIZE_OPTIONS = [
  { label: 20, value: 20 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
  { label: 500, value: 500 },
]

export const SCREENING_REPORT_TYPE_ID = 1

export const HAS_INDEPENDENT_COMPANY = {
  INDEPENDENT_COMPANIES: 'INDEPENDENT_COMPANIES',
  NON_INDEPENDENT_COMPANIES: 'NON_INDEPENDENT_COMPANIES',
}

export const HAS_INDEPENDENT_COMPANY_OPTIONS = [
  {
    id: HAS_INDEPENDENT_COMPANY.INDEPENDENT_COMPANIES,
    name: 'screening.INDEPENDENT_COMPANIES',
  },
  {
    id: HAS_INDEPENDENT_COMPANY.NON_INDEPENDENT_COMPANIES,
    name: 'screening.NON_INDEPENDENT_COMPANIES',
  },
]
